import React from "react";
import SupportPanel from "../support";
// import NotificationPanel from '../notification';

const MenuPage = () => {
  return (
    <div className="flex justify-center mt-10 mb-20">
      <div className="2xl:w-8/12 xl:w-10/12 lg:w-10/12 w-11/12 shadow-lg">
        <SupportPanel />
      </div>
    </div>
  );
};

export default MenuPage;
